<template>
  <div class="">
    <v-container>
      <v-form
        ref="form"
        v-model="internalValid"
        lazy-validation
      >
        <v-row>
          <v-col
            cols="12"
            class="mb-1"
          >
            <SmallSectionTitle
              section-number="1"
              :title="$t('main.enums.sections.contact_infos')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="displayField['email']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.email"
              :required="requiredField['email']"
              :rules="fieldRules['email']"
              :label="$t('main.enums.fields.email')"
              icon="mdi-email-outline"
              :default="record.email"
              clear-on-focus
              @input="removeFieldErrors('email')"
            />
          </v-col>

          <v-col cols="6" />

          <v-col
            v-if="displayField['home_phone_number']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.home_phone_number"
              :required="requiredField['home_phone_number']"
              :rules="fieldRules['home_phone_number']"
              :label="$t('main.enums.fields.home_phone_number')"
              icon="mdi-deskphone"
              :default="record.home_phone_number"
              format="phone"
              clear-on-focus
              @input="removeFieldErrors('home_phone_number')"
            />
          </v-col>
          <v-col
            v-if="displayField['mobile_phone_number']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.mobile_phone_number"
              :required="requiredField['mobile_phone_number']"
              :rules="fieldRules['mobile_phone_number']"
              :label="$t('main.enums.fields.mobile_phone_number')"
              icon="mdi-cellphone"
              :default="record.mobile_phone_number"
              format="phone"
              clear-on-focus
              @input="removeFieldErrors('mobile_phone_number')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="mb-1"
          >
            <SmallSectionTitle
              section-number="2"
              :title="$t('main.enums.sections.postal_infos')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="displayField['home_address_line_1']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.home_address_line_1"
              :required="requiredField['home_address_line_1']"
              :rules="fieldRules['home_address_line_1']"
              :label="$t('main.enums.fields.home_address_line_1')"
              icon="mdi-home-circle-outline"
              :default="record.home_address_line_1"
              @input="removeFieldErrors('home_address_line_1')"
            />
          </v-col>
          <v-col
            v-if="displayField['home_address_line_2']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.home_address_line_2"
              :required="requiredField['home_address_line_2']"
              :rules="fieldRules['home_address_line_2']"
              :label="$t('main.enums.fields.home_address_line_2')"
              icon="mdi-home-circle-outline"
              :default="record.home_address_line_2"
              @input="removeFieldErrors('home_address_line_2')"
            />
          </v-col>
          <v-col
            v-if="displayField['home_address_line_3']"
            md="6"
            cols="12"
          >
            <TextInput
              v-model="record.home_address_line_3"
              :required="requiredField['home_address_line_3']"
              :rules="fieldRules['home_address_line_3']"
              :label="$t('main.enums.fields.home_address_line_3')"
              icon="mdi-home-circle-outline"
              :default="record.home_address_line_3"
              @input="removeFieldErrors('home_address_line_3')"
            />
          </v-col>
          <v-col
            v-if="displayField['home_country']"
            md="6"
            cols="12"
          >
            <MultiselectInput
              v-model="record.home_country"
              :required="requiredField['home_country']"
              :rules="fieldRules['home_country']"
              :label="$t('main.enums.fields.home_country')"
              :default="record.home_country"
              :options="enumsOptions.countries"
              item-text="label"
              item-value="code"
              @input="removeFieldErrors('home_country')"
            />
          </v-col>
          <v-col
            v-if="displayHomeCity && displayField['home_insee_code']"
            md="6"
            cols="12"
          >
            <MultiselectInput
              v-model="record.home_insee_code"
              :required="requiredField['home_insee_code']"
              :rules="fieldRules['home_insee_code']"
              :label="$t('main.enums.fields.home_insee_code')"
              :default="record.home_insee_code"
              :options="enumsOptions.cities"
              item-text="label"
              item-value="code"
              @input="removeFieldErrors('home_insee_code')"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import { getFieldsByProperty } from '@/utils/person.utils'

  import SmallSectionTitle from '@/components/ui/common/SmallSectionTitle'

  import TextInput from '@/components/ui/inputs/TextInput'
  import MultiselectInput from '@/components/ui/inputs/MultiselectInput'
  import personTabFields from '@/components/RightDrawer/helpers/PersonTab.fields.json'

  export default {
    components: {
      SmallSectionTitle,
      TextInput,
      MultiselectInput,
    },
    mixins: [mixinUi, CommonMixin,],
    props: {
      formValid: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        localFields: personTabFields.contact,
        record: {},
      }
    },
    computed: {
      internalValid: {
        get() {
          return this.formValid
        },
        set(value) {
          return this.$emit('update:formValid', value)
        },
      },
      displayField() {
        const allFields = this.requiredAttributes.concat(this.optionalAttributes)

        return getFieldsByProperty(allFields, this.localFields)
      },
      requiredField() {
        return getFieldsByProperty(this.requiredAttributes, this.localFields)
      },
      fieldRules() {
        const rules = {}

        this.localFields.forEach((item) => {
          rules[item] = []
          if (this.formErrors[item]) {
            rules[item].push(this.$t(`main.enums.error.${this.formErrors[item]}`))
          }
        })

        return rules
      },
      displayHomeCity() {
        return this.record.home_country === 'FRANCE'
      },
    },
    watch: {
      formErrors: function(val) {
        this.$refs.form.validate()
      },
    },
    mounted() {
      this.record = Object.assign({}, this.selectedProfile)
      if (Object.keys(this.formErrors).length > 0) {
        this.$refs.form.validate()
      }
    },
    methods: {
      getRecord() {
        return this.record
      },
    },
  }
</script>

<style scoped lang="scss">
.description {
  font-size: 16px;
  color: $color-103_102_102_5;
}
</style>
